import Resource from '@/plugins/sdk/Resource'
import { OBJECT, BOOLEAN, INTEGER, NUMBER, DATETIME, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'
import Carrier from '@/plugins/sdk/resources/Carrier'
// import File from '@/plugins/sdk/resources/File'

export default class extends Resource {
  static name = 'invoiceimport'

  static get fields () {
    return {
      id: new UUID(),
      type: new STRING(),
      status: new STRING(),
      filename: new STRING(),
      reference: new STRING(),
      total_value: new NUMBER(),
      gst_value: new NUMBER(),
      fuel_value: new NUMBER(),
      date: new DATETIME(),
      key_in_total_ex: new NUMBER(),
      key_in_fuel: new NUMBER(),
      count: new INTEGER(),
      hash: new STRING(),
      admin_fee: new NUMBER(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      carrier: new ITEM(Carrier),
      progress: new NUMBER(),
      // file: new ITEM(File)
      file: new OBJECT()
    }
  }

  static get sortables () {
    return [
      { field: 'filename', label: 'Filename' },
      { field: 'reference', label: 'Reference' },
      { field: 'total_value', label: 'Total Value' },
      { field: 'gst_value', label: 'GST Value' },
      { field: 'fuel_value', label: 'Fuel Value' },
      { field: 'date', label: 'Date' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'account.account_name', label: 'Account Name' },
      { field: 'carrier.carrier_name', label: 'Carrier Name' }
    ]
  }
}
